// frontend/src/components/TierBadge.tsx
//
// Displays a badge showing if an app requires a paid subscription

import { Crown } from 'lucide-react';
import { SubscriptionTier } from '../lib/supabase';

interface TierBadgeProps {
  tier: SubscriptionTier;
  size?: 'sm' | 'md';
  showIcon?: boolean;
}

export function TierBadge({ tier, size = 'sm', showIcon = true }: TierBadgeProps) {
  // Don't show badge for free tier
  if (tier === 'free') return null;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
  };

  const iconSize = size === 'sm' ? 'h-3 w-3' : 'h-4 w-4';

  return (
    <span 
      className={`inline-flex items-center gap-1 rounded-full font-medium bg-theme-primary/10 text-theme-primary ${sizeClasses[size]}`}
    >
      {showIcon && <Crown className={iconSize} />}
      Paid
    </span>
  );
}